import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../public/fonts/Graphik/Light.woff2%22,%22weight%22:%22300%22,%22style%22:%22normal%22},{%22path%22:%22../public/fonts/Graphik/Bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22}],%22declarations%22:[{%22prop%22:%22font-family%22,%22value%22:%22Graphik%22}],%22variable%22:%22--font-graphik-extended%22,%22display%22:%22swap%22,%22preload%22:false,%22adjustFontFallback%22:false,%22fallback%22:[%22system-ui%22,%22sans-serif%22]}],%22variableName%22:%22graphikExtended%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'graphikExtended', system-ui, sans-serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
